export const isJupiterLite = process?.env?.NEXT_PUBLIC_IS_EXTERNAL === 'true';
export const APP_NAME = 'PolyAI Agent Studio';

export const ENV = (
  process.env.NEXT_PUBLIC_POLYAI_ENVIRONMENT || ''
).toLowerCase();
export const REGION = (
  process.env.NEXT_PUBLIC_POLYAI_REGION || ''
).toLowerCase();

export const IS_PLG_PROD = process.env.NEXT_PUBLIC_IS_PLG === 'true';

export const IS_LOCALHOST =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '[::1]');
